/* סיווג עסקים שב"אחר" ב-4 התקופות האחרונות. בחירת קטגוריה מעדכנת את כל הפעולות של העסק,
   וזיכרון העסקים לומד מהן, כך שבסריקות הבאות העסק יסווג לבד. */
import { useState } from 'react';
import { fmt } from '../../lib/format.js';
import { extractJSON } from '../../lib/text.js';
import { askAI } from '../../lib/ai.js';
import { cats, cat } from '../../domain/categories.js';
import { unclassifiedMerchants } from '../../domain/merchants.js';
import { buildSuggestPrompt } from '../../domain/scan/prompts.js';
import { Sheet } from '../../components/ui.jsx';
import { openModal } from '../../app/nav.js';
import { UI, toast, useApp } from '../../store/ui.js';
import { setTxCat } from '../../store/actions.js';

export function openClassify() {
  openModal(() => <ClassifySheet />);
}

function ClassifySheet() {
  useApp();
  const [sug, setSug] = useState({});
  const [busy, setBusy] = useState(false);
  const list = unclassifiedMerchants(UI.viewKey);
  const cs = cats('expense').filter((c) => c.id !== 'other');
  const total = list.reduce((s, e) => s + e.sum, 0);

  async function classify(e, catId, silent) {
    await setTxCat(e.ids, catId);
    setSug((s) => { const n = { ...s }; delete n[e.k]; return n; });
    if (!silent) { const c = cat('expense', catId); toast('✅ ' + e.name + ' → ' + c.icon + ' ' + c.label + (e.ids.length > 1 ? ' (' + e.ids.length + ' פעולות)' : '')); }
  }
  async function suggest() {
    const part = list.slice(0, 40);
    setBusy(true);
    try {
      const arr = extractJSON(await askAI('classify', buildSuggestPrompt(part))) || [];
      const out = {};
      arr.forEach((r) => { const e = part[r.i]; if (e && r.cat && r.cat !== 'other' && cs.some((c) => c.id === r.cat)) out[e.k] = r.cat; });
      setSug(out);
      toast(Object.keys(out).length ? '✨ ' + Object.keys(out).length + ' הצעות. בדוק ואשר' : 'לא נמצאו הצעות בטוחות');
    } catch (e) {
      toast('⚠️ ' + e.message);
    }
    setBusy(false);
  }
  async function applyAll() {
    const ks = Object.keys(sug);
    for (const k of ks) { const e = list.find((x) => x.k === k); if (e) await classify(e, sug[k], true); }
    toast('✅ ' + ks.length + ' עסקים סווגו');
  }

  return (
    <Sheet title="🏷️ סיווג עסקים">
      {!list.length ? (
        <div style={{ textAlign: 'center', padding: '26px 10px' }}>
          <div style={{ fontSize: '2rem' }}>✓</div>
          <div style={{ fontSize: '.95rem', fontWeight: 700, marginTop: 6 }}>כל העסקים מסווגים</div>
          <div className="note mt6">ב-4 התקופות האחרונות אין הוצאות ב"אחר"</div>
        </div>
      ) : (
        <>
          <div className="sub mb12" style={{ fontSize: '.93rem' }}>{list.length} עסקים, {fmt(total)} שלא מסווגים. בחירת קטגוריה מסווגת את כל הפעולות של העסק, והאפליקציה זוכרת אותה לסריקות הבאות.</div>
          <div className="row mb12">
            <button className="ubtn ubtn-outline" style={{ flex: 1 }} disabled={busy} onClick={suggest}>{busy ? 'מנתח...' : '✨ הצע סיווג אוטומטי'}</button>
            {Object.keys(sug).length > 0 && <button className="ubtn ubtn-primary" style={{ flex: 1 }} onClick={applyAll}>✓ אשר את כל ההצעות</button>}
          </div>
          {list.slice(0, 40).map((e) => (
            <div key={e.k} style={{ padding: '11px 0', borderTop: '1px solid var(--border)' }}>
              <div className="row-b" style={{ alignItems: 'baseline' }}>
                <b className="ellipsis" style={{ fontSize: '.9rem' }}>{e.name}</b>
                <span className="nowrap sub">{fmt(e.sum)} · {e.n === 1 ? 'פעולה אחת' : e.n + ' פעולות'}</span>
              </div>
              <div className="chips-scroll">
                {cs.map((c) => <button key={c.id} className={'cat-chip' + (sug[e.k] === c.id ? ' on' : '')} onClick={() => classify(e, c.id)}>{c.icon} {c.label}</button>)}
              </div>
            </div>
          ))}
          {list.length > 40 && <div className="note" style={{ padding: '10px 0' }}>ועוד {list.length - 40} עסקים קטנים</div>}
        </>
      )}
    </Sheet>
  );
}
